<template>
    <div class="window-wrapper window-file-load-error">
        <div class="window-overlay"></div>
        <div class="window window-small">
            <div class="window-inner">
                <div class="window-one-column">
                    <div class="window-text">Не удалось загрузить один или несколько файлов. Пожалуйста, выберите не более 5-ти файлов до 10 Мб каждый</div>

                    <div class="button-block">
                        <button @click="closeWindow" class="button button-dark button-close-window">ОК</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FileLoadErrorWindow",
    methods: {
        closeWindow() {
            $('.window-wrapper').removeClass('window-open');
            $('body').removeClass('blocked');
        }
    }
}
</script>

<style scoped>

</style>